import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const useStyles = makeStyles({
  root: {
    background: 'white',
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    // padding: '10px',
    overflow: 'hidden',
    // margin: 10
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  },
  table: {
    overflow: 'auto',
    minHeight: '100px',
    height: 700,
    marginTop: 30,
    marginBottom: 20,
  },
});

export const FBADiagnosticDataTable = ({ fbaData, fbaDiagnostics }) => {

  try {
    // STYLES
    const classes = useStyles();

    if (!fbaDiagnostics || fbaDiagnostics?.length === 0) return (<></>);

    const columns = [
      {
        field: 'tmb',
        headerName: 'Tmb',
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        // type: 'string'
      },
      {
        field: 'rnp',
        headerName: 'RNP',
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        // type: 'string'
      },
      {
        field: 'rnpPrime',
        headerName: 'RNP\'',
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        // type: 'string'
      },
      {
        field: 'owr',
        headerName: 'OWR (stb/stb)',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        // type: 'string'
      },
      {
        field: 'cumOil',
        headerName: 'Cum. Oil (stb)',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        // type: 'string'
      },
      
    ];

    let rows = [];

    fbaDiagnostics?.forEach((value, index) => {
      rows.push({
        id: index,
        tmb: (value?.tmb)?.toFixed(4) || 0,
        rnp: (value?.rnp)?.toFixed(4) || 0,
        rnpPrime: (value?.rnpPrime)?.toFixed(4) || 0,
        owr: fbaData?.[index]?.owr?.toFixed(4) || 0,
        cumOil: fbaData?.[index]?.cumOil?.toFixed(4) || 0,
      });
    });

    return (
      <div className={classes.root}>
        <DataGrid
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[10,25,50,100]}
          disableSelectionOnClick
          className={classes.table}
          components={{
            Toolbar: GridToolbar,
          }}
        />
      </div>
    );
  } catch (error) {
    return <></>
  };
};
